import { useState } from 'react'

const TextBlock = ({ content }) => {
    const [open, setOpen] = useState(false)

    const toggleOpen = () => {
        setOpen(!open)
    }

    return (
        <div className={`text-block ${open ? 'open' : ''}`}>
            {open && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                />
            )}
            <a tabIndex="0" onClick={toggleOpen}>
                {open ? <T>news.label.read.less</T> : <T>news.label.read.more</T>}
            </a>
        </div>
    )
}

export default TextBlock
